import formatDecimal from'./format-decimal';const exponent=a=>(a=formatDecimal(Math.abs(a)),a?a[1]:NaN);export default exponent;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-utils/src/number-converter/exponent.js
// module id = Wwt2
// module chunks = 1